import { createSelector } from 'helpers/reselect'

export const getBrandName = ({ brandDetails: { data: { name }}}) => name

export const getDescription = ({ brandDetails: { data: { description }}}) => description

export const getFilterData = ({ brandDetails: { filters }}) => filters

export const getFiltersMap = ({ brandDetails: { filtersMap }}) => filtersMap

export const getSelectedFilters = createSelector(
  [getFilterData],
  filters =>
    filters.reduce((acc, curr) => {
      if (curr.refinements) {
        return [...acc, ...curr.refinements.filter(({ selected }) => selected)]
      }

      return acc
    }, [])
)
